module.exports = __webpack_public_path__ + "static/media/link.a6ccde0a.svg";